export const getFontStyle = ({
  isBold,
  isItalic,
}: {
  isBold: boolean;
  isItalic: boolean;
}): string => {
  if (isBold && isItalic) {
    return "bold italic";
  }

  if (isBold) {
    return "bold";
  }

  if (isItalic) {
    return "italic";
  }

  return "normal";
};

export const getFontSize = ({
  scale,
  fontSize,
}: {
  scale: { x: number; y: number };
  fontSize: number;
}): number => Math.round(scale.y * fontSize);
